import baseAPI from "@/http";

const router = "api/municipioIbge";

export const cityIBGEAPI = {
  getNome: (UF, codIBGE) =>
    baseAPI.get(`${router}/obter-por-uf-codigomunicipio/${UF}/${codIBGE}`),
  getByUf: (UF) => baseAPI.get(`${router}/obter-por-id/${UF}`),
};
